export default class PromotionController {
  constructor(resource) {
    this._resource = resource;
  }

  getById(promotionId) {
    return this._resource(`promotion/${promotionId}`)
      .get()
      .then(
        res => {
          return res.body;
        },
        err => {
          throw new Error(err);
        }
      );
  }

  get() {
    return this._resource('promotion')
      .get()
      .then(
        res => {
          return res.body;
        },
        err => {
          throw new Error(err);
        }
      );
  }

  create(promotion) {
    return this._resource('promotion')
      .save(promotion)
      .then(
        res => {
          return res.body;
        },
        err => {
          throw new Error(err);
        }
      );
  }

  getByClient() {
    return this._resource('promotion/client')
      .get()
      .then(
        res => {
          return res.body;
        },
        err => {
          throw new Error(err);
        }
      );
  }

  getPromotionByClientAndVehicleModel(clientId, vehicleModel) {
    return this._resource(
      `promotion/client/${clientId}/vehicle-model/${vehicleModel}`
    )
      .get()
      .then(
        res => {
          return res.body.promotions;
        },
        err => {
          console.error(err);
        }
      );
  }

  getByCategory(category) {
    return this._resource(`promotion/category/${category}`)
      .get()
      .then(
        res => {
          return res.body;
        },
        err => {
          console.error(err);
        }
      );
  }
  updatePromotionClient(promotions) {
    return this._resource(`promotionClient/update`)
      .update(promotions)
      .then(
        res => {
          return res.body;
        },
        err => {
          console.error(err);
        }
      );
  }

  getByClientIdFromAdm(clientId) {
    return this._resource(`promotion/client/adm/${clientId}`)
      .get()
      .then(
        res => {
          return res.body;
        },
        err => {
          throw new Error(err);
        }
      );
  }
  getByCategory(category) {
    return this._resource(`promotion/category/${category}`)
      .get()
      .then(
        res => {
          return res.body;
        },
        err => {
          console.error(err);
        }
      );
  }

  disable(promotionId) {
    return this._resource(`promotion/disable/${promotionId}`)
      .update()
      .then(
        res => {
          return res.body;
        },
        err => {
          throw new Error(err);
        }
      );
  }

  getPromotionVehicleModelsByPromotion(promotionId) {
    return this._resource(`promotionVehicleModel/${promotionId}`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  getPromotionClientsByPromotion(promotionId) {
    return this._resource(`promotionClient/${promotionId}`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  subscribeRecurrent(promotionId, credit_card_id, installments) {
    return this._resource(
      `promotion/subscribe/${promotionId}/${credit_card_id}`
    )
      .save({ installments })
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  subscribeRecurrentAdm(assinatura) {
    return this._resource('promotion/subscribe-adm')
      .save(assinatura)
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  checkActivePromotion(promotionId) {
    return this._resource(`promotion_user/user`)
      .get()
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  getPromotionVehicleModelsByPromotionAndModel(promotionId, modelId) {
    return this._resource(`promotionVehicleModel`)
      .get({ promotionId, modelId })
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  update(id, promotion) {
    return this._resource(`promotion/${id}`)
      .update(promotion)
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  updateOrder(promotion) {
    return this._resource('promotion/order')
      .update({ id: promotion.id, order: promotion.order })
      .then(res => res.body)
      .catch(e => {
        throw e;
      });
  }

  getAllRecurrentType() {
    return this._resource('promotionRecurrent')
      .get()
      .then(res => res.body)
      .catch(error => console.log(error));
  }

  getAllRecurrentTypeByClient(clientId) {
    return this._resource(`promotionRecurrentByClient/${clientId}`)
      .get()
      .then(res => res.body)
      .catch(error => console.log(error));
  }
}
